import { environment } from 'src/environments/environment';
import { ConsoleLogger } from './console-logger';
import { NullLogger } from './null-logger';
import { Logger } from './logger';
import { ConsoleTimestampLogger } from './console-timestamp-logger';

export const LoggerFactory = (): Logger => 
  environment.production ? new NullLogger() : new ConsoleTimestampLogger();
